import React, { useState } from 'react'
import { X, Edit, Lock, Loader2, CheckCircle2, Info, Clock, History, Sparkles } from "lucide-react";
import axios from "axios";
import { ConfirmModal,FreezeResultModal ,ALLOCATION_REASON_CONFIG ,getAllocationConfig ,AllocationInfoModal ,FreezeIcon ,handleFreezeConfirmed,handleUpdateDepartment} from './Supervisorhelper';


const View_worker_supervisor = ({
  showworkermodal,
  setshowworkermodal,
  workerList,
  loadingWorkers = false,
  collapsedDepts,
  setCollapsedDepts,
  departments = [],
  company,
  onWorkerUpdated,
  onRefetchWorkers,
  token,freezeDepartmentApi ,updateWorkerDepartmentApi
}) => {

  const workers = workerList[1] || [];
  console.log(workerList);
  const workersummary = workerList[0]?.[0] || {};

  const [editmodal, seteditmodal] = useState(false);
  const [editingWorker, setEditingWorker] = useState(null);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState("");
  const [updating, setUpdating] = useState(false);
  const [updateError, setUpdateError] = useState(null);

  const [freezeConfirm, setFreezeConfirm] = useState({
    open: false,
    type: null,
    deptName: null,
    loading: false,
  });

  const [freezeResult, setFreezeResult] = useState({
    open: false,
    data: null,
  });

  // Allocation info modal 
  const [allocationModal, setAllocationModal] = useState({
    open: false,
    worker: null,
  });

  const openAllocationModal = (w) => {
    setAllocationModal({ open: true, worker: w });
  };

  const closeAllocationModal = () => {
    setAllocationModal({ open: false, worker: null });
  };

  //  Freeze handlers
  const openFreezeDeptConfirm = (e, deptName) => {
    e.stopPropagation();
    setFreezeConfirm({ open: true, type: 'dept', deptName, loading: false });
  };

  const openFreezeAllConfirm = () => {
    setFreezeConfirm({ open: true, type: 'all', deptName: null, loading: false });
  };

  const closeFreezeConfirm = () => {
    setFreezeConfirm({ open: false, type: null, deptName: null, loading: false });
  };

 

  //  Edit dept 
  const openEditModal = (w) => {
    const freshWorker = workers.find((lw) => lw.attendanceId === w.attendanceId) || w;
    setEditingWorker(freshWorker);
    setSelectedDepartmentId(String(freshWorker.departmentId || ""));
    setUpdateError(null);
    seteditmodal(true);
  };

  const grouped = workers.reduce((acc, w) => {
    const key = w.department || "Not Assigned";
    if (!acc[key]) acc[key] = [];
    acc[key].push(w);
    return acc;
  }, {});

  return (
    <div
      className="fixed inset-0 z-[100] mt-8 flex items-end sm:items-center justify-center bg-black/50 sm:p-4"
      onClick={() => setshowworkermodal(false)}
    >
      <div
        className="bg-white w-full h-full sm:h-auto sm:rounded-2xl sm:shadow-2xl sm:max-w-lg lg:max-w-2xl xl:max-w-3xl sm:max-h-[85vh] flex flex-col overflow-hidden animate-in slide-in-from-bottom sm:slide-in-from-bottom-0 duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Drag handle */}
        <div className="flex justify-center pt-3 pb-2 sm:hidden flex-shrink-0">
          <div className="w-10 h-1.5 bg-gray-300 rounded-full" />
        </div>

        {/* Header */}
        <div className="flex items-start justify-between px-4 lg:px-6 py-3 lg:py-4 border-b border-indigo-100 flex-shrink-0 gap-3">
          <div className="flex flex-col gap-2.5 min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-indigo-50 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-[16px] h-[16px] text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <div>
                <p className="text-sm lg:text-base font-medium text-indigo-950 leading-tight">Worker list</p>
                <p className="text-[11px] lg:text-xs text-indigo-400 leading-tight">
                  {company?.companyName ? `${company.companyName}` : "Company"}
                </p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2">
              <div className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-indigo-50 rounded-full">
                <span className="text-[11px] lg:text-xs text-indigo-500">Total worker Scanned:</span>
                <span className="text-[11px] lg:text-xs font-medium text-indigo-900">
                  {workersummary.Totalworker}
                </span>
              </div>
                            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-amber-50 rounded-full">
                <span className="text-[11px] lg:text-xs text-amber-600">Allotment Pending:</span>
                <span className="text-[11px] lg:text-xs font-medium text-amber-800">
                  {workersummary.pending}
                </span>
              </div>
              <div className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-indigo-50 rounded-full">
                <span className="text-[11px] lg:text-xs text-emerald-600">Allocation In Process:</span>
                <span className="text-[11px] lg:text-xs font-medium text-emerald-600">
                  {workersummary.inProcess}
                </span>
              </div>

              <div className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-emerald-50 rounded-full">
                <span className="text-[11px] lg:text-xs text-emerald-600">Alloted:</span>
                <span className="text-[11px] lg:text-xs font-medium text-emerald-800">
                  {workersummary.allotted}
                </span>
              </div>
            </div>

           <button
  onClick={openFreezeAllConfirm}
  disabled={
    workers.length === 0 ||
    workers.filter(
      (w) => !w.isDepartmentAllotted && (w.department || "Not Assigned") !== "Not Assigned"
    ).length === 0
  }
  className="w-full lg:w-auto lg:self-start lg:px-8 inline-flex items-center justify-center gap-1.5 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 active:scale-95 rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-indigo-600 disabled:active:scale-100"
>
  <span className="text-[13px] lg:text-sm font-medium text-white">Confirm Allocation for All</span>
</button>
          </div>

          <button
            onClick={() => setshowworkermodal(false)}
            className="flex-shrink-0 flex items-center justify-center w-[26px] h-[26px] rounded-lg border border-indigo-100 bg-indigo-50 text-indigo-400 hover:bg-indigo-100 hover:text-indigo-600 active:scale-95 transition-all"
            aria-label="Close"
          >
            <X className="w-[13px] h-[13px]" />
          </button>
        </div>

        {/* List */}
        <div className="overflow-y-auto flex-1">
          {loadingWorkers ? (
            <div className="flex flex-col items-center justify-center h-full text-gray-400 py-16 gap-2">
              <Loader2 className="h-6 w-6 animate-spin text-indigo-500" />
              <p className="text-sm">Loading workers...</p>
            </div>
          ) : workers.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-gray-400 py-16">
              <p className="text-base">No workers found</p>
            </div>
          ) : (
            <table className="w-full text-sm border-collapse" style={{ tableLayout: "fixed" }}>
              <thead className="sticky top-0 bg-white z-10" />
              <tbody>
                {Object.entries(grouped)
                  .sort(([a], [b]) => {
                    if (a === "Not Assigned") return -1;
                    if (b === "Not Assigned") return 1;
                    return 0;
                  })
                  .map(([deptName, deptWorkers]) => {
                    const isCollapsed = collapsedDepts[`modal_${deptName}`];
                    const allFrozen = deptWorkers.every((w) => w.isDepartmentAllotted);

                    return (
                      <React.Fragment key={deptName}>
                        <tr
                          className="bg-blue-50 border-y border-blue-100 cursor-pointer select-none active:bg-blue-100"
                          onClick={() =>
                            setCollapsedDepts((prev) => ({
                              ...prev,
                              [`modal_${deptName}`]: !prev[`modal_${deptName}`],
                            }))
                          }
                        >
                          <td className="px-2 lg:px-4 py-2 lg:py-2.5" style={{ width: '70%' }}>
                            <div className="flex items-center gap-2 min-w-0">
                              <svg
                                className="h-4 w-4 text-blue-600 transition-transform duration-200 flex-shrink-0"
                                style={{ transform: isCollapsed ? "rotate(-90deg)" : "rotate(0deg)" }}
                                fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
                              >
                                <polyline points="6 9 12 15 18 9" />
                              </svg>
                              <span className="text-xs lg:text-sm font-semibold text-blue-900">
                                Department: {deptName}
                              </span>
                              <span
                                className="inline-flex items-center justify-center w-3.5 h-3.5 rounded-full bg-blue-500 text-white font-bold leading-none"
                                style={{ fontSize: '7px' }}
                              >
                                {deptWorkers.length}
                              </span>
                            </div>
                          </td>
<td className="px-2 lg:px-4 py-2 lg:py-2.5 text-right" style={{ width: '30%' }}>
  {deptName !== "Not Assigned" && (
    <button
      onClick={(e) => !allFrozen && openFreezeDeptConfirm(e, deptName)}
      disabled={allFrozen}
      className={`inline-flex items-center gap-1.5 px-2.5 lg:px-3 py-1 lg:py-1.5 text-xs lg:text-sm font-semibold rounded-full border transition-all duration-150
        ${allFrozen
          ? "border-gray-300 text-gray-400 bg-gray-100 cursor-not-allowed"
          : "border-blue-500/50 text-blue-900 bg-blue-500/10 hover:bg-blue-500/20 hover:border-blue-400 cursor-pointer"
        }`}
    >
      {allFrozen ? "Allotted" : "Confirm Allotment"}
    </button>
  )}
</td>
                        </tr>

                        {!isCollapsed &&
                          deptWorkers.map((w, idx) => (
                            <tr
                              key={w.attendanceId || idx}
                              className="border-b border-gray-100 active:bg-gray-50 transition-colors"
                            >
                              <td className="px-3.5 lg:px-5 py-3 lg:py-3.5" style={{ width: '90%' }}>
                                <div
                                  className="flex items-center gap-3 cursor-pointer group/profile"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openAllocationModal(w);
                                  }}
                                >
                                  <img
                                    src={w.profile_photo}
                                    alt=""
                                    onError={(e) => { e.target.src = "/default-avatar.png"; }}
                                    className="w-10 h-10 lg:w-11 lg:h-11 rounded-full object-cover border border-indigo-100 flex-shrink-0 bg-indigo-50 group-hover/profile:ring-2 group-hover/profile:ring-indigo-300 transition-all"
                                  />
                                  <div className="relative group min-w-0">
                                    <div className="font-medium text-sm lg:text-base text-gray-900 truncate group-hover/profile:text-indigo-700 transition-colors">{w.name}</div>
                                    <div className="text-gray-600 text-xs lg:text-sm truncate">{w.workerCode}</div>
                                    <div className="absolute left-0 bottom-full mb-1 z-20 hidden group-hover:flex items-center px-2 py-1 rounded-md bg-gray-900 text-white text-xs whitespace-nowrap">
                                      {w.phone}
                                    </div>
                                  </div>
                                </div>
                              </td>
<td className="px-3 lg:px-5 py-3 lg:py-3.5 text-right" style={{ width: '30%' }}>
  <div className="flex items-center justify-end gap-1.5" onClick={(e) => e.stopPropagation()}>
    {w.department && (
      <button
        onClick={!w.isDepartmentAllotted ? () => openEditModal(w) : undefined}
        disabled={w.isDepartmentAllotted}
        className="w-8 h-8 lg:w-9 lg:h-9 rounded-lg hover:bg-gray-100 active:scale-95 flex items-center justify-center transition-all disabled:cursor-not-allowed disabled:hover:bg-transparent"
        title={w.isDepartmentAllotted ? "Department is Allotted" : "Change department"}
      >
        {w.isDepartmentAllotted
          ? <Lock size={14} color="#9b9b9b" />
          : <Edit size={14} color="#534AB7" />}
      </button>
    )}
  </div>
</td>
                            </tr>
                          ))
                        }
                      </React.Fragment>
                    );
                  })}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/*  Edit Department Modal  */}
      {editmodal &&  (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]"
          onClick={() => seteditmodal(false)}
        >
          <div
            className="bg-white rounded-lg p-6 lg:p-7 max-w-md lg:max-w-lg w-full mx-2"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between">
              <h2 className="text-lg lg:text-xl font-semibold">Edit Department</h2>
              <X className="h-5 w-5 cursor-pointer text-gray-500 hover:text-gray-700" onClick={() => seteditmodal(false)} />
            </div>
            <div className="mt-2 space-y-1 text-sm lg:text-base text-gray-700">
              <p><span className="font-semibold">Department:</span> {editingWorker?.department || "Not Assigned"}</p>
              <p><span className="font-semibold">Name:</span> {editingWorker?.name}</p>
              {editingWorker?.workerCode && (
                <p><span className="font-semibold">Worker Code:</span> {editingWorker.workerCode}</p>
              )}
            </div>
            <div className="flex flex-col gap-3 mt-3">
              <div className="flex flex-col gap-1">
                <label className="text-[10px] sm:text-xs font-semibold text-gray-400 uppercase tracking-wider">Department</label>
                <select
                  value={selectedDepartmentId}
                  onChange={(e) => setSelectedDepartmentId(e.target.value)}
                  disabled={departments.length === 0}
                  className="w-full px-3 py-2 lg:py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-sm lg:text-base text-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                >
                  {departments.length === 0 ? (
                    <option value="">No departments available</option>
                  ) : (
                    <>
                      {!selectedDepartmentId && <option value="">Select department</option>}
                      {departments.map((d) => (
                        <option key={d._id} value={String(d._id)}>{d.name}</option>
                      ))}
                    </>
                  )}
                </select>
              </div>
              {updateError && <p className="text-red-600 text-xs">{updateError}</p>}
              <button
                onClick={()=>handleUpdateDepartment({
  editingWorker,
  selectedDepartmentId,
  setUpdating,
  setUpdateError,
  departments,
  setEditingWorker,
  setCollapsedDepts,
  onWorkerUpdated,
  onRefetchWorkers,
  seteditmodal,
  updateWorkerDepartmentApi
})}
                disabled={!selectedDepartmentId || updating}
                className="px-3 py-2 lg:py-2.5 bg-indigo-600 text-white text-sm lg:text-base rounded-md hover:bg-indigo-700 disabled:bg-indigo-300 flex items-center justify-center gap-2"
              >
                {updating && <Loader2 className="h-4 w-4 animate-spin" />}
                {updating ? "Updating..." : "Update Department"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/*  Freeze Confirm Modal  */}
      <ConfirmModal
        isOpen={freezeConfirm.open}
        onClose={closeFreezeConfirm}
        
onConfirm={() => {
  handleFreezeConfirmed({ company, workers, freezeConfirm, setFreezeConfirm, closeFreezeConfirm, onRefetchWorkers, setFreezeResult,freezeDepartmentApi });
}}
        loading={freezeConfirm.loading}
        icon={<FreezeIcon />}
        iconBg="bg-amber-50"
        title={
          freezeConfirm.type === 'all'
            ? "Allot all departments?"
            : `Confirm Allotment in ${freezeConfirm.deptName}?`
        }
        description={
          freezeConfirm.type === 'all'
            ? "All workers across every department will be Allotted"
            : `Workers in "${freezeConfirm.deptName}" will be Allotted`
        }
        confirmLabel={freezeConfirm.type === 'all' ? "Yes, Allot all" : "Yes, Allot"}
        confirmClass="bg-amber-600 hover:bg-amber-700"
      />

      {/*  Freeze Result Modal  */}
      <FreezeResultModal
        isOpen={freezeResult.open}
        onClose={() => setFreezeResult({ open: false, data: null })}
        result={freezeResult.data}
      />

      {/*  Allocation Info Modal  */}
      <AllocationInfoModal
        isOpen={allocationModal.open}
        onClose={closeAllocationModal}
        worker={allocationModal.worker}
      />
    </div>
  );
};

export default View_worker_supervisor;